import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { gettysburgConfig } from "./data";

export default function GettysburgPage() {
  return <CityPageTemplate config={gettysburgConfig} />;
}